/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// This file is auto-generated from .env configuration
// Do not edit this file directly - edit .env instead

export const environment = {
  production: false,
  HOST: '',
  BASE_URL: 'https://dev.fitradio.com',
  IMG_URL: 'https://dev.fitradio.com',
  DDEX: 'https://vg1ohjwtq2.execute-api.us-east-1.amazonaws.com/prod',
  UPLOAD: 'https://dev.fitradio.com',
  NODE_API_URL: 'https://node.fitradio.com',
  ALGOLIA_API_URL: 'https://monorepo-generic-api-dev.fitradio.com/api/algolia',
};



// WEBPACK FOOTER //
// /srv/dev/FitRadioAdmin2/src/environments/environment.ts